import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const AttachmentDownloadError = () => (
  <div className='attachment-download-error'>
    <figure className='attachment-download-error__icon'>
      <img src={getStaticImage('/icons/orange-brand/icon-close-circle-grey.svg')} alt='Error' />
    </figure>
    <p className='attachment-download-error__title'>{lang('dashboard_failed-receive-file')}</p>
    <p className='attachment-download-error__subtitle'>{lang('dashboard_request-user-send-file-again')}</p>
  </div>
)

export default AttachmentDownloadError
